import * as FilePond from "filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageCrop from "filepond-plugin-image-crop";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import FilePondPluginImageEdit from "filepond-plugin-image-edit";

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css";

import Toastify from "toastify-js";
import $ from "jquery";
import "jquery-validation";
import { Modal } from "bootstrap";

import Croppie from "croppie";
import "croppie/croppie.css";
import { fixFilePath } from "../useful";

FilePond.registerPlugin(FilePondPluginFileValidateType);
FilePond.registerPlugin(FilePondPluginImageExifOrientation);
FilePond.registerPlugin(FilePondPluginImagePreview);
FilePond.registerPlugin(FilePondPluginImageCrop);
FilePond.registerPlugin(FilePondPluginImageResize);
FilePond.registerPlugin(FilePondPluginImageTransform);
FilePond.registerPlugin(FilePondPluginImageEdit);

var c = null;
let isNewFile = true;
const workshopId = $("#workshop_id").val();
const videoForDelete = [];

// Создание экземпляра FilePond для аватара
const workshopAvatar = FilePond.create(
  document.querySelector("#workshop-avatar"),
  {
    name: "avatar",
    maxFiles: 1,
    credits: false,
    acceptedFileTypes: ["image/*"],
    maxFileSize: "5MB",
    labelIdle: `<span class="w-100 h-100 filepond--label-action flex justify-content-center fw-semibold text-green align-items-center"> 
              <svg class="me-2" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.07013 16.5H12.9301C15.0001 16.5 15.8251 15.2325 15.9226 13.6875L16.3126 7.4925C16.4176 5.8725 15.1276 4.5 13.5001 4.5C13.0426 4.5 12.6226 4.2375 12.4126 3.8325L11.8726 2.745C11.5276 2.0625 10.6276 1.5 9.86263 1.5H8.14513C7.37263 1.5 6.47263 2.0625 6.12763 2.745L5.58763 3.8325C5.37763 4.2375 4.95763 4.5 4.50013 4.5C2.87263 4.5 1.58263 5.8725 1.68763 7.4925L2.07763 13.6875C2.16763 15.2325 3.00013 16.5 5.07013 16.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.875 6H10.125" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 13.5C10.3425 13.5 11.4375 12.405 11.4375 11.0625C11.4375 9.72 10.3425 8.625 9 8.625C7.6575 8.625 6.5625 9.72 6.5625 11.0625C6.5625 12.405 7.6575 13.5 9 13.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Загрузить фото 
            </span>`,
    labelMaxFileSizeExceeded: "Файл больше 5МБ",
    labelMaxFileSize: "Максимальный размер файла это: {filesize}",

    imageCropAspectRatio: "1:1",
    allowImageCrop: true,
    imageResizeTargetWidth: 200,
    imageResizeTargetHeight: 200,
    stylePanelLayout: "compact",
    styleLoadIndicatorPosition: "center bottom",
    styleProgressIndicatorPosition: "right bottom",
    styleButtonRemoveItemPosition: "left bottom",
    styleButtonProcessItemPosition: "right bottom",
    onaddfile: (error, file) => {
      if (error) return;

      if (!isNewFile) return;

      const newFile = file.file;
      const modalEl = document.getElementById("cropModal");
      const myModal = new Modal(modalEl);

      myModal.show();

      // создаём экземпляр
      if (c) {
        c.destroy();
      }

      const handleShown = () => {
        c = new Croppie(document.getElementById("croppie-wrapper"), {
          viewport: { width: 200, height: 200 },
          boundary: { width: 300, height: 300 },
        });

        const reader = new FileReader();
        reader.onload = function (e) {
          c.bind({ url: e.target.result });
        };
        reader.readAsDataURL(newFile);
      };

      // обработчик только один раз
      modalEl.addEventListener("shown.bs.modal", handleShown, { once: true });
    },
  }
);

workshopAvatar.on("addfile", () => {
  $(".create-workshop__avatar-warning").hide();
});

workshopAvatar.on("removefile", () => {
  $(".create-workshop__avatar-warning").show();
});

$("#workshop-avatar").on("FilePond:init", function () {
  $("#workshop-avatar .filepond--action-remove-item").on("click", function () {
    isNewFile = true;
  });
});

// Шаг 2: обрезка и передача результата в FilePond
$("#crop-image").on("click", function () {
  if (c) {
    c.result({
      type: "blob",
      size: "viewport",
    }).then(function (resp) {
      isNewFile = false;

      workshopAvatar.removeFiles();

      const newPhoto = new File([resp], "avatar.png", { type: "image/png" });

      workshopAvatar.addFile(newPhoto, { silent: true }).then(() => {
        $("#workshop-avatar .filepond--action-remove-item").on(
          "click",
          function () {
            isNewFile = true;
          }
        );
      });
    });
    c.destroy();
    c = null;
  }
});

const workTrailer = FilePond.create(document.querySelector("#videos"), {
  name: "videos",
  maxFiles: 5,
  allowMultiple: true,
  credits: false,
  allowFileEncode: false,
  labelIdle:
    '<span class="filepond--label-action w-100 h-100">Перетащите ваши файлы в поле или  выберите файлы вручную </span>',
  labelMaxFileSizeExceeded: "Файл больше 5МБ",
  labelMaxFileSize: "Максимальный размер файла это: {filesize}",
  acceptedFileTypes: ["video/mp4", "video/webm"],
  onaddfile: (error, fileItem) => {
    if (error) return;

    if (fileItem.file.type.startsWith("video/")) {
      const video = document.createElement("video");
      video.controls = true;
      video.style.width = "100%";
      video.style.height = "260px";
      video.style.marginTop = "10px";
      video.src = URL.createObjectURL(fileItem.file);

      // Найдём DOM элемент, в который FilePond вставляет превью
      const itemElement = document.querySelector(
        `#filepond--item-${fileItem.id}`
      );

      if (itemElement) {
        // Вставляем видеоплеер под прогрессбар
        itemElement.appendChild(video);
      }
    }
  },
});

const workshopTrailer = FilePond.create(document.querySelector("#video"), {
  name: "video",
  maxFiles: 1,
  credits: false,
  allowMultiple: false,
  allowFileEncode: false,
  labelIdle: `<span class="button filepond--label-action w-100 h-100 examples__create ghost-success flex flex-column align-items-center justify-center">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.15" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#2E695D"></path>
            <path d="M16 11.25H12.75V8C12.75 7.59 12.41 7.25 12 7.25C11.59 7.25 11.25 7.59 11.25 8V11.25H8C7.59 11.25 7.25 11.59 7.25 12C7.25 12.41 7.59 12.75 8 12.75H11.25V16C11.25 16.41 11.59 16.75 12 16.75C12.41 16.75 12.75 16.41 12.75 16V12.75H16C16.41 12.75 16.75 12.41 16.75 12C16.75 11.59 16.41 11.25 16 11.25Z" fill="#2E695D"></path>
        </svg>
        Нажмите или перетащите видео
    </span>`,
  labelMaxFileSizeExceeded: "Файл больше 5МБ",
  labelMaxFileSize: "Максимальный размер файла это: {filesize}",
  acceptedFileTypes: ["video/mp4", "video/webm"],
  onaddfile: (error, fileItem) => {
    if (error) return;

    if (fileItem.file.type.startsWith("video/")) {
      const video = document.createElement("video");
      video.controls = true;
      video.style.width = "100%";
      video.style.height = "320px";
      video.style.marginTop = "10px";
      video.src = URL.createObjectURL(fileItem.file);

      // Найдём DOM элемент, в который FilePond вставляет превью
      const itemElement = document.querySelector(
        `#filepond--item-${fileItem.id}`
      );

      if (itemElement) {
        // Вставляем видеоплеер под прогрессбар
        itemElement.appendChild(video);
      }
    }
  },
});

$("#categoryModal li").on("click", function () {
  const li = $(this);

  const categoryTag = `
    <div data-value="${li.data("value")}" class="col-auto category__list__item">
        <span class="order-card__category-tag workshop__categories-item flex align-items-center gap-md rounded-pill px-3 py-2 mt-0 text-center h-100">
            ${li.text()}
            <svg class="delete cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="gray" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"></path>
            </svg>
        </span>
    </div>`;

  $(".categories__list").append(categoryTag);
  li.hide();
  Modal.getInstance($("#categoryModal")).hide();
});

$(".categories__list").on("click", ".delete", function () {
  const categoryItem = $(this).closest(".category__list__item");
  const categoryId = categoryItem.data("value");

  categoryItem.remove();

  // показываем только соответствующее li
  $("#categoryModal li").each(function () {
    if ($(this).data("value") === categoryId) {
      $(this).show();
    }
  });
});

function createWorkshop() {
  let formData = new FormData();

  // const avatar = workshopAvatar.getFiles();
  const name = $("#name").val();
  const userId = $("#user_id").val();
  const workshopId = $("#workshop_id")?.val();
  const city = $("#location_id").val();
  const email = $("#email").val();
  const phone = $("#phone").val();
  const description = $("#description").val();
  const categories = $(".category__list__item");
  const _token = $("#csrf-token").val();

  const allCategories = $.map(categories, (item) => {
    return Number($(item).data("value"));
  });
  let jsonCategories = JSON.stringify([...allCategories]);

  // formData.append("avatar", avatar[0]?.file);
  formData.append("name", name);
  formData.append("user_id", userId);

  if (workshopId) {
    formData.append("workshop_id", workshopId);
  }

  formData.append("location_id", city);
  formData.append("email", email);
  formData.append("phone", phone);
  formData.append("description", description);
  formData.append("category_ids", jsonCategories);
  formData.append("_token", _token);

  const isEdit = $(".workshop__main-save").data("type") == "edit";

  if (isEdit) {
    formData.append("_method", "PATCH");
  }

  $(".loading").show();
  fetch(`/workshop${isEdit ? "/" + workshopId : ""}`, {
    method: "POST",
    headers: {"X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content},
    body: formData,
  })
    .then((response) => {
      $(".loading").hide();
      if (response.ok) {
        return response.json();
      } else {
        Toastify({
          text: "Не удалось сохранить изменения мастерской",
          gravity: "bottom", // `top` or `bottom`
          position: "right",
          duration: 3000,
        }).showToast();

        throw new Error(response);
      }
    })
    .then(() => {
      $(".loading").hide();
      // location.reload();
    });
}

let workshopToActive = null;

// если хочешь забирать id из кнопки открытия (опционально)
$(document).on("click", ".workshop__open-active-modal", function () {
  workshopToActive = $(this).data("id") || $("#workshop_id").val();
  $("#confirmWorkshopActiveBtn").data("id", workshopToActive);
});

$(document).on("click", ".workshop__set-active", function () {
  const workshopId = $(this).data("id") || workshopToActive || $("#workshop_id").val();
  const _token = $("#csrf-token").val();

  if (!workshopId) {
    Toastify({
      text: "Не найден ID мастерской",
      gravity: "bottom",
      position: "right",
      duration: 3000,
    }).showToast();
    return;
  }

  const formData = new FormData();
  formData.append("_token", _token);
  formData.append("_method", "PUT");
  formData.append("status", "active");

  $(".loading").show();

  fetch(`/workshop/${workshopId}`, {
    method: "POST",
    body: formData,
  })
    .then((res) => {
      $(".loading").hide();

      if (!res.ok) {
        Toastify({
          text: "Не удалось вернуть мастерскую в публикацию",
          gravity: "bottom",
          position: "right",
          duration: 3000,
        }).showToast();
        throw new Error("Active failed");
      }

      return res.json().catch(() => ({}));
    })
    .then(() => {
      Toastify({
        text: "Мастерская снова опубликована",
        gravity: "bottom",
        position: "right",
        duration: 2500,
      }).showToast();

      // закрыть модалку (если нужно)
      const modalEl = document.getElementById("activeWorkshopModal");
      const modal = Modal.getInstance(modalEl);
      modal?.hide();

      location.reload();
    })
    .catch((e) => {
      $(".loading").hide();
      console.error(e);
    });
});


$(document).on("click", ".workshop__set-unactive", function () {
  const idFromBtn = $(this).data("id");
  const idFromHidden = $("#workshop_id").val();

  const id = idFromBtn || idFromHidden;
  setWorkshopStatusUnactive(id);
});

function setWorkshopStatusUnactive(workshopId) {
  const _token = $("#csrf-token").val();

  if (!workshopId) {
    Toastify({
      text: "Не найден ID мастерской",
      gravity: "bottom",
      position: "right",
      duration: 3000,
    }).showToast();
    return;
  }

  const formData = new FormData();
  formData.append("_token", _token);
  formData.append("_method", "PUT");        // как у тебя при edit
  formData.append("status", "unactive");    // твой новый статус

  $(".loading").show();

  fetch(`/workshop/${workshopId}`, {
    method: "POST",
    body: formData,
  })
    .then((res) => {
      $(".loading").hide();

      if (!res.ok) {
        Toastify({
          text: "Не удалось изменить статус мастерской",
          gravity: "bottom",
          position: "right",
          duration: 3000,
        }).showToast();
        throw new Error("Status update failed");
      }

      // если бэк возвращает json
      return res.json().catch(() => ({}));
    })
    .then(() => {
      Toastify({
        text: "Мастерская деактивирована",
        gravity: "bottom",
        position: "right",
        duration: 2500,
      }).showToast();

      // чаще всего логично обновить страницу/перерисовать UI
      location.reload();
    })
    .catch((e) => {
      $(".loading").hide();
      console.error(e);
    });
}


//JOB EXAMPLES

$(".workshop__main-save")?.on("click", (e) => createWorkshop());

$("#my-dropzone")?.validate({
  rules: {
    name: {
      required: true,
      minlength: 3,
    },
    city: {
      minlength: 3,
    },
    email: {
      minlength: 3,
      email: true,
    },
    phone: {
      minlength: 11,
      pattern:
        /^(\+7|8)?[\s\-]?\(?\d{3}\)?[\s\-]?\d{3}[\s\-]?\d{2}[\s\-]?\d{2}$/,
    },
    description: {
      minlength: 100,
      required: true,
    },
  },
  messages: {
    name: {
      required: "Название мастерской не должно быть пустым",
      minlength: "Название мастерской должно содержать минимум 3 символа",
    },
    city: {
      required: "Введите город",
      minlength: "Город должен содержать минимум 3 символа",
    },
    email: {
      minlength: "Email должен содержать минимум 3 символа",
      email: "Введите корректный email",
    },
    phone: {
      minlength: "Телефон должен содержать минимум 11 символов",
      pattern: "Введите корректный номер телефона РФ",
    },
    description: {
      required: "Описание мастерской не должно быть пустым",
      minlength: "Описание мастерской должно содержать минимум 100 символов",
    },
  },
});

if ($("#my-dropzone")[0]) {
  const isValid = $("#my-dropzone")?.valid();
  $(".workshop__main-save")?.prop("disabled", !isValid);

  $("#my-dropzone").on("input change", "input, textarea, select", function () {
    const isValid = $("#my-dropzone")?.valid();
    $(".workshop__main-save")?.prop("disabled", !isValid);
  });
}

if (window.location.href.includes("workshop/edit")) {
  let avatarFiles = $(".filePondAvatar").data("files");

  let avatar;

  window.addEventListener("load", () => {
    // --- Аватар ---
    if (avatarFiles && avatarFiles["result"]) {
      avatar = avatarFiles["result"].map((item) => fixFilePath(item));
      workshopAvatar.addFile(avatar, { silent: true }).then(() => {
        isNewFile = false; // после предзагрузки считаем файл "старым"
      });
    } else {
      // если ничего нет при старте → сразу ждём новые файлы
      isNewFile = true;
    }
  });

  function addVideo(file, field) {
    const formData = new FormData();
    formData.append("id", workshopId);
    formData.append("model", "Workshop");
    formData.append("field", field);
    formData.append("files[]", file);

    $(".loading").show()

    return fetch("/api/files", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then(() => {
        $(".loading").hide();
        location.reload();
      })
      .catch(console.error);
  }

  function deleteVideo(file) {
    const fullPath = file; // полный URL

    const data = {
      id: workshopId,
      model: "Workshop",
      paths: [fullPath],
    };

    fetch("/api/files", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then(() => {
        location.reload();
      })
      .catch(console.error);
  }

  let fileToDelete = null;

  $(document).on(
    "click",
    ".workshop__edit-delete-video, .workshop__edit-delete-trailer",
    function () {
      fileToDelete = $(this).data("file");

      const name = $(this).data("name") || "это видео";
      $("#deleteVideoName").text(name);

      $("#confirmVideoDeleteBtn").data("file", fileToDelete);
    }
  );

  $("#confirmVideoDeleteBtn").on("click", function () {
    const fullPath = $(this).data("file");

    deleteVideo(fullPath);
  });

  $("#workshop__trailer").on("change", async function (e) {
    const file = e.target.files[0];
    if (!file) return;

    const response = await addVideo(file, "video");
    console.log(response);
  });

  $("#workshop__videos").on("change", async function (e) {
    const file = e.target.files[0];
    if (!file) return;

    const response = await addVideo(file, "videos");
    console.log(response);
  });
}
